import React from "react";

import "./loading.css";

function Loading() {
  return (
    <div className="loading_ani">
      <div class="loader">Loading...</div>
    </div>
  );
}

export default Loading;
